import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Inline, Stack } from '@atlaskit/primitives/compiled';
import HeadingSkeleton from '@atlaskit/skeleton';

import { CardList } from '@atlassian/studio-browse-kit/ui/card-list';
import { AgentCardSkeleton } from '@atlassian/studio-browse-kit/agent-card-skeleton';
import { HeroCardSkeleton } from '@atlassian/studio-browse-kit/common/ui/HeroCard/HeroCardSkeleton';
import { RecommendedPanel } from '../../recommended-list/components/RecommendedPanel';

const RECOMMENDED_CARD_COUNT = 4;
const RECOMMENDED_COLUMNS = 2;

const skeletonRecommendedKeys = Array.from(
	{ length: RECOMMENDED_CARD_COUNT },
	(_, index) => `recommended-skeleton-card-${index}`,
);

export const RecommendedSkeleton = ({ testId }: { testId?: string }): React.JSX.Element => {
	const isUplift = fg('rovo_agents_studio_browse_kit_uplift');
	const CardSkeleton = isUplift ? HeroCardSkeleton : AgentCardSkeleton;

	const cards = (
		<CardList
			columns={RECOMMENDED_COLUMNS}
			testId={testId ? `${testId}--recommended-items` : undefined}
		>
			{skeletonRecommendedKeys.map((key, index) => (
				<CardSkeleton
					key={key}
					testId={testId ? `${testId}--recommended-card-${index}` : undefined}
				/>
			))}
		</CardList>
	);
	return (
		<Stack space="space.200">
			<Inline alignBlock="center">
				<HeadingSkeleton width={isUplift ? 160 : 80} height={20} isShimmering={!isUplift} />
			</Inline>
			{isUplift ? (
				cards
			) : (
				<RecommendedPanel testId={testId ? `${testId}--recommended` : undefined}>
					{cards}
				</RecommendedPanel>
			)}
		</Stack>
	);
};
